import { base_path } from "environment";

export const all_routes = {
  home: "/",
  login: "/Login",
  forgotPassword: "/Forgot-Password",
  verify_otp: "/Verify-Email-OTP",
  recovery_mail: "/Password-Sent-Success",
  reset_password: "/Reset-User-Password",
  updatePassword: "/UpdatePassword",
  recovery_mail_password_success: "/PasswordSentSuccess",
  base_path: base_path,
  // base_path: "/PayrollV2",
  // base_path: "/PayrollLive",
  dashboard: "/Dashboard",
  master: "/Company/Setting/Master",
  acadamics: "/Acadamics",
  bank: "/Bank",
  add_bank: "/Bank/AddBank",
  edit_bank: "/Bank/EditBank",
  group: "/Group",
  country: "/Country",
  relationship: "/Relationship",
  nationality: "/Nationality",
  identification: "/Identification",
  race: "/Race",
  visa_type: "/VisaType",
  cpfContribution: "/CPFContribution",
  cpfContributionRate: "/CPFContributionRate",
  add_cpfContributionRate: "/CPFContributionRate/Add",
  edit_cpfContributionRate: "/CPFContributionRate/Edit",
  cpfPercentage: "/CPFPercentage",
  add_cpfPercentage: "/CPFPercentage/Add",
  add_multi_cpfPercentage: "/CPFPercentage/Multiple",
  edit_cpfPercentage: "/CPFPercentage/Edit",
  cpfPercentageFLI: "/CPFPercentageFLI",
  add_cpfPercentageFLI: "/CPFPercentageFLI/Add",
  add_multi_cpfPercentageFLI: "/CPFPercentageFLI/Multiple",
  edit_cpfPercentageFLI: "/CPFPercentageFLI/Edit",
  cpfType: "/CPFType",
  employmentType: "/EmploymentType",
  contractType: "/ContractType",

  location: "/Location",
  location_add: "/Add-Location",
  location_edit: "/Edit-Location",
  passType: "/PassType",
  paymode: "/Paymode",
  levyType: "/LevyType",
  trade: "/Trade",
  momTrade: "/MOMTrade",
  employeeStatus: "/EmployeeStatus",
  employeeType: "/EmployeeType",
  employeeWorkType: "/EmployeeWorkType",
  workingDayType: "/WorkingDayType",
  dormitory: "/Dormitory",
  dormitory_add: "/Dormitory/Add-Dormitory",
  dormitory_edit: "/Dormitory/Edit-Dormitory",
  levyAmountType: "/LevyAmountType",
  foreignerlevy: "/Foreignerlevy",
  insurancetype: "/Insurancetype",
  addinsurancetype: "/AddInsurancetype",
  editinsurancetype: "/EditInsurancetype",
  vechile_master: "/Master/Vehicle",
  vehicleaccident: "/Vehicleaccident",
  dieselusage: "/Dieselusage",
  vehicleCategory: "/VehicleCategory",
  vehicleType: "/VehicleType",
  vehiclemaintenance: "/VehicleMaintenance",
  vehicleinformation: "/VehicleInformation",
  addvehicleinformation: "/Add-VehicleInformation",
  editvehicleinformation: "/Edit-VehicleInformation",
  vehicleexpenses: "/Vehicleexpenses",
  addvehicleexpenses: "/Add-Vehicleexpenses",
  editvehicleexpenses: "/Edit-Vehicleexpenses",
  vehicleindemnity: "/Vehicleindemnity",
  addvehicleindemnity: "/Add-Vehicleindemnity",
  editvehicleindemnity: "/Edit-Vehicleindemnity",
  employee: "/Employee",
  employee_list: "/EmployeeDirectory",
  employee_add: "/EmployeeDirectory/AddEmployee",
  employee_edit: "/EmployeeDirectory/EditEmployee",
  employee_view: "/EmployeeDirectory/ViewEmployee",
  employee_import: "/EmployeeDirectory/ImportEmployee",
  employee_working_hours: "/EmployeeDirectory/EmpWorkingHours",
  employee_hike: "/EmployeeDirectory/HikeDetails",
  employee_login_details: "/EmployeeDirectory/LoginDetails",
  employee_offer_letter: "/EmployeeDirectory/OfferLetter",
  upload_employee_offer_letter:
    "/EmployeeDirectory/OfferLetter/UploadOfferLetter",
  add_employee_offer_letter: "/EmployeeDirectory/OfferLetter/AddOfferLetter",
  employee_movements: "/EmployeeDirectory/EmployeeMovements",
  department_list: "/Employee/Department/DepartmentList",
  designation_list: "/Employee/Designation/DesignationList",
  emp_allowance_deduction: "/Employee/AllowanceAndDeductions",
  add_emp_allowance_deduction: "/Employee/AllowanceAndDeductions/Add",
  edit_emp_allowance_deduction: "/Employee/AllowanceAndDeductions/Edit",
  import_emp_allowance_deduction: "/Employee/AllowanceAndDeductions/Import",
  generate_emp_allowance_deduction: "/Employee/AllowanceAndDeductions/Generate",
  emp_allowance: "/Employee/Allowance",
  add_emp_allowance: "/Employee/Allowance/Add",
  edit_emp_allowance: "/Employee/Allowance/Edit",
  emp_deductions: "/Employee/Deduction",
  add_emp_deductions: "/Employee/Deduction/Add",
  edit_emp_deductions: "/Employee/Deduction/Edit",
  leave: "/Leave",
  leave_type: "/LeaveType",
  leave_manangement: "/LeaveManagement",
  employee_leave: "/EmployeeLeave",
  employee_leave2: "/EmployeeLeave2",
  apply_leave: "/ApplyLeave",
  un_applied_leave: "/UnAppliedLeave",
  view_apply_leave: "/ViewApplyLeave",
  public_holiday: "/PublicHoliday",
  attendance: "/Attendance",
  time_log: "/TimeLog",
  import_time_log: "/ImportTimeLog",
  attendance_qr: "/AttendanceQRCode",
  attendance_management: "/AttendanceManagement",
  attendance_filter: "/Attendance-Filter",
  attendance_day: "/DayAttendance",
  attendance_month: "/MonltyAttendance",
  attendance_import: "/ImportAttendance",
  attendance_timesheet: "/Timesheet",
  attendance_listing: "/Attendance/AttendanceListing",
  claim: "/Claim",
  claim_type: "/Type/Claim-Type",
  claim_list: "/Manage/Claim-List",
  claim_add: "/Manage/Claim-Add",
  claim_add_multiple: "/Manage/Claim-Multiple",
  claim_edit: "/Manage/Claim-Edit",
  payroll: "/Payroll",
  addition: "/Addition",
  deduction: "/Deduction",
  payroll_lits: "/PayrollList",
  payroll_stage: "/PayrollStage",
  payroll_stage_edit: "/PayrollStage/Edit",
  payroll_stage_view: "/PayrollStage/View",
  payroll_edit: "/Payroll/PayrollList/Edit",
  generate_payroll: "/GeneratePayroll",
  payroll_bank_payment_list: "/BankPaymentList",
  payroll_bank_file: "/PayrollBankFile",
  payslip: "/DownloadPayslip",
  report: "/Report",
  attendance_report: "/Attendance-Report",
  leave_report: "/Leave-Report",
  emp_leave_history: "/Emp-Leave-History",
  payroll_report: "/Monthly-Payroll-Summary",
  payslip_report: "/Payslip-Report",
  expiry_report: "/Expiry-Report",
  forecast_report: "/Forecast-Report",
  man_hour_project_report: "/Man-Hour-Project-Report",
  daily_work_order_report: "/Daily-Work-Order-Report",
  emp_details_report: "/Employee-Details-Report",
  emp_levy_report: "/Levy-Report",
  emp_leave_history_report: "/Leave-History-Report",
  employee_count_report: "/Employee-Count-Report",
  project_costing_report: "/Project-Costing-Report",
  setting: "/Company/Setting",
  company_setting: "/Company-Setting",
  email_configuration: "/Email-Configuration",
  user: "/Company/Setting/User",
  user_master: "/Company/Setting/User/User-Master",
  employee_master: "/Company/Setting/User/Employee-Master",
  employee_master_list: "/List",
  user_master_list: "/List",
  add_user_master: "/Add",
  edit_user_master: "/Edit",
  view_user_master: "/View",
  user_group: "/Company/Setting/User/User-Group",
  user_group_list: "/List",
  add_user_group: "/Add",
  edit_user_group: "/Edit",
  user_role: "/Company/Setting/User/User-Roles",
  user_role_management: "/Company/Setting/User/User-Role-Management",
  user_permission: "/User-Permission",
  user__permission_list: "/List",
  add_user__permission: "/Add",
  edit_user__permission: "/Edit",
  user_profile: "/User-Profile",
  filter_attendance: "/AttendanceManagement/FilterAttendace",
  shift_type: "/ShiftType",
  shift: "/Shift",
  shift_policy: "/Shift-Policy",
  add_shift_policy: "/AddShiftPolicy",
  edit_shift_policy: "/EditShiftPolicy",
  shift_rotation: "/Shift-Rotation",
  employee_shift_mapping: "/Employee-Shift-Mapping",
  project: "/Project",
  project_list: "/Project",
  add_project: "/AddProject",
  edit_project: "/EditProject",
  task_list: "/Task",
  add_task: "/AddTask",
  edit_task: "/EditTask",
  download_timelog: "/DownloadTimesheet",
  loan_and_advance: "/LoanAndAdvance",
  advance_payment: "/LoanAndAdvance/Advance-Payment",
  advance_payment_list: "/Advance-Payment-List",
  advance_payment_add: "/Advance-Payment-Add",
  advance_payment_edit: "/Advance-Payment-Edit",
  advance_payment_details: "/Advance-Payment-Details",
  report_list: "/Report/Report-List",
  contract_report: "/Report/Contract-Report",
  addition_deduction_report: "/Report/Addition-Deduction-Report",
  advance_payment_report: "/Report/Advance-Payment-Report",
  advance_repayment_report: "/Report/Advance-Repayment-Report",
  project_report: "/Report/Project-Report",
  unAuthorized: "/unAuthorized",
  email_alert: "/Email-Alert-Configuration",
  add_email_alert: "/Email-Alert-Configuration/Add",
  edit_email_alert: "/Email-Alert-Configuration/Edit",
  ket_information: "/Employee/KET/KETInformation",
  fill_ket_information: "/Employee/KET/KETInformation/FillKetForm",
  audit_log: "/Company/Setting/Audit-Log",
  announcement_list: "/Company/Announcement/AnnouncementList",
  add_announcement: "/Company/Announcement/AddAnnouncement",
  edit_announcement: "/Company/Announcement/EditAnnouncement",
  ir8a_formlist: "/Government/IRAS/IR8A/IR8AFormList",
  ir8a_generateForm: "/Government/IRAS/IR8A/IR8AGenerateForm",
  ir8a_edit_form: "/Government/IRAS/IR8A/EditIR8AForm",
  ir8a_eSubmission: "/Government/IRAS/IR8A/IR8A-eSubmission",
  notification_list: "/Notification/NotificationList",
  contract_template: "/Company/Setting/Master/ContractTemplate",
  add_contract_template: "/Company/Setting/Master/ContractTemplate/Add",
  edit_contract_template: "/Company/Setting/Master/ContractTemplate/Edit",
  emp_contract_list: "/Employee/Contract/ContractList",
  // audit_log_list: "/Setting/Audit-Log/",
};
